/** Native disclosure enhancement; Shopify source links remain server-rendered. */
(() => {
class BpGuidedNavigation extends HTMLElement {
  connectedCallback() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    this.sections = [...this.querySelectorAll('.bp-nav__section')];
    this.service = this.querySelector('.bp-nav__service');
    this.isDrawer = this.dataset.mode === 'drawer';
    this.setAttribute('data-enhanced', '');
    this.addEventListener('toggle', event => this.onToggle(event), { capture: true, signal });
    this.addEventListener('click', event => this.onClick(event), { signal });
    this.addEventListener('keydown', event => this.onKeydown(event), { signal });
    if (!this.isDrawer) {
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.closeSections();
      }, { signal });
      document.addEventListener('focusin', event => {
        if (!this.contains(event.target)) this.closeSections();
      }, { signal });
    } else {
      this.closest('x-drawer')?.addEventListener('dialog:after-hide', () => this.closeSections(), { signal });
    }
    this.desktopQuery = window.matchMedia('(min-width: 1000px)');
    this.resizeObserver = new ResizeObserver(() => this.sizePanels());
    this.querySelectorAll('.bp-nav__group-content').forEach(panel => this.resizeObserver.observe(panel));
    this.desktopQuery.addEventListener('change', () => {
      this.closeSections();
      if (this.isDrawer && this.desktopQuery.matches) this.closest('x-drawer')?.hide?.();
    }, { signal });
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.resizeObserver?.disconnect();
  }

  sizePanels() {
    if (this.isDrawer || !this.desktopQuery.matches) return;
    this.sections.filter(section => section.open).forEach(section => {
      const content = section.querySelector('.bp-nav__group[open] .bp-nav__group-content');
      const groups = section.querySelector('.bp-nav__groups');
      if (content && groups) groups.style.minHeight = `${Math.ceil(content.getBoundingClientRect().height + 44)}px`;
    });
  }

  closeSections(except = null) {
    this.sections.forEach(section => {
      if (section !== except) section.open = false;
    });
  }

  onToggle(event) {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !this.contains(details) || !details.open) return;
    if (details.classList.contains('bp-nav__section')) {
      this.closeSections(details);
      if (!this.isDrawer && this.service) details.querySelector('.bp-nav__panel').append(this.service);
      const groups = [...details.querySelectorAll('.bp-nav__group')];
      if (this.isDrawer) {
        groups.forEach(group => { group.open = false; });
        details.querySelector('[data-bp-back="section"]')?.focus({ preventScroll: true });
      } else if (!groups.some(group => group.open)) {
        if (groups[0]) groups[0].open = true;
      }
    } else if (details.classList.contains('bp-nav__group')) {
      details.parentElement.querySelectorAll('.bp-nav__group').forEach(group => {
        if (group !== details) group.open = false;
      });
      if (this.isDrawer) details.querySelector('[data-bp-back="group"]')?.focus({ preventScroll: true });
    }
    this.sizePanels();
  }

  onClick(event) {
    const summary = event.target.closest('summary');
    if (!this.isDrawer && summary?.parentElement.matches('.bp-nav__group[open]')) {
      event.preventDefault();
      return;
    }
    const button = event.target.closest('button');
    if (!button || !this.contains(button)) return;
    if (button.hasAttribute('data-bp-close') || button.dataset.bpBack === 'section') {
      const section = button.closest('.bp-nav__section');
      section.open = false;
      section.querySelector(':scope > summary')?.focus();
    } else if (button.dataset.bpBack === 'group') {
      const group = button.closest('.bp-nav__group');
      group.open = false;
      group.querySelector(':scope > summary')?.focus();
    }
  }

  onKeydown(event) {
    if (event.key !== 'Escape') return;
    const section = event.target.closest('.bp-nav__section[open]');
    if (!section) return;
    event.preventDefault();
    event.stopPropagation();
    const group = this.isDrawer ? event.target.closest('.bp-nav__group[open]') : null;
    const details = group || section;
    details.open = false;
    details.querySelector(':scope > summary')?.focus();
  }
}

if (!customElements.get('bp-guided-navigation')) {
  customElements.define('bp-guided-navigation', BpGuidedNavigation);
}
})();
